import { CircularProgress, LinearProgress, Typography } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext } from "react"
import { Redirect } from "react-router"
import PlayerWithControls from "~/components/Common/PlayerWithControls"
import LearningCuesList from "~/components/Lessons/LearningCues/LearningCuesList"
import LearningCuesTimeline from "~/components/Lessons/LearningCues/LearningCuesTimeline"
import LearningCuesContext from "~/contexts/LearningCues"
import LessonContext from "~/contexts/Lesson"
import { VideoContainer } from "~/contexts/Video"
import useThumbnail from "~/hooks/useThumbnail"
import Page from "~/pages/Page"

import useReadOnly from "~/hooks/useReadOnly"
import Box from "../../../../../../components/Common/Box"
import useStyles from "./styles"

const Cues = ({ routes = [], ...rest }) => {
  const classes = useStyles()
  const isReadOnly = useReadOnly()

  const { lesson, videoUrl } = useContext(LessonContext)
  const { learningCuesQuery, resetLearningCues } =
    useContext(LearningCuesContext)

  const lessonThumbnail = useThumbnail(lesson?.thumbnail, 1920)

  // useEffect(() => {
  //   return () => {
  //     resetLearningCues()
  //   }
  // }, [])

  const lockdown =
    lesson?.published === 1 ||
    (lesson?.published === 0 &&
      lesson?.has_been_published === 1 &&
      lesson?.archived === 0) ||
    isReadOnly

  if (learningCuesQuery.isLoading) {
    return <LinearProgress color="primary" />
  }

  return (
    <Page>
      {lesson?.video_id !== null && (
        <VideoContainer lesson={lesson}>
          {({ ReactPlayerProps }) => (
            <Box
              display="flex"
              flexDirection="column"
              height="100%"
              overflow="hidden"
            >
              <LearningCuesTimeline lockdown={lockdown} />
              <Box className={classes.bottomSection}>
                <Box className={classes.videoBox}>
                  <Box width="100%">
                    {videoUrl?.isLoading && (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                      >
                        <CircularProgress color="primary" size={15} />
                      </Box>
                    )}
                    {/* fixes video box size due to flex styles */}
                    {videoUrl?.data?.data?.readyToStream && (
                      <PlayerWithControls
                        url={`https://customer-${
                          import.meta.env.VITE_CLOUDFLARE_CUSTOMER_ID
                        }.cloudflarestream.com/${
                          videoUrl?.data?.data.videoToken
                        }/manifest/video.m3u8`}
                        poster={lessonThumbnail}
                        ReactPlayerProps={ReactPlayerProps}
                        duration={lesson?.duration || 0}
                      />
                    )}
                    {videoUrl?.data?.data?.readyToStream === false && (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                      >
                        <Typography
                          variant="subtitle2"
                          style={{ fontWeight: 700, color: "white" }}
                        >
                          Video not ready to stream, come back in a few minutes
                        </Typography>
                        <CircularProgress
                          color="primary"
                          size={15}
                          className="mt-2"
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
                <LearningCuesList lockdown={lockdown} />
              </Box>
            </Box>
          )}
        </VideoContainer>
      )}
      {lesson?.video_id === null && <Redirect to={`/lessons/${lesson.id}`} />}
    </Page>
  )
}

Cues.propTypes = {
  routes: PropTypes.array,
}

export default Cues
